<template>
  <div v-loading="loading">
    <el-form
      label-width="80px"
      @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="交易时间:">
            <date-range-select
              v-model="daterange"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单来源:">
            <order-source-select
              v-model="config.source"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收件人:">
            <el-input
              v-model.trim="config.receiverName"
              clearable=""
              placeholder="请输入收件人姓名">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单号:">
            <el-input
              v-model.trim="config.code"
              clearable=""
              placeholder="请输入订单号">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="销售部门:">
            <el-input
              v-model.trim="config.saleDepartmentName"
              clearable=""
              placeholder="请输入销售部门">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="销售人员:">
            <el-input
              v-model.trim="config.saleStaffName"
              clearable=""
              placeholder="请输入销售人员">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注:">
            <el-input
              v-model.trim="config.remark"
              clearable=""
              placeholder="请输入备注">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label=""
            label-width="0">
            <el-button
              type="primary"
              @click="handleCurrentChange(1)">查询</el-button>
            <el-tooltip content="信息完整的信息才能进行批量审单">
              <el-button
                type="success"
                :disabled="multipleSelection.length === 0"
                @click="batchCheck">批量审单<span v-if="multipleSelection.length > 0">(共{{ multipleSelection.length }}项)</span></el-button>
            </el-tooltip>
            <no-pager-checkbox
              v-model="noPager"
              :pagerNo="pagerNo"
              :pagerYes="pagerYes"
              style="margin-left: 5px" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      ref="table"
      border
      :data="list"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        fixed="left"
        :selectable="selectable"
        width="40">
      </el-table-column>
      <el-table-column
        label="订单号"
        fixed="left"
        :resizable="false"
        width="170">
        <template slot-scope="{row}">
          <link-route :link-to="`/orders-detail?vendorId=${row.parentOwnerCode}&salesOrderId=${row.id}&code=${row.code}`">
            {{ row.code }}
          </link-route>
        </template>
      </el-table-column>
      <el-table-column
        label="收件人"
        min-width="200"
        :resizable="false">
        <template slot-scope="{row}">
          <div>
            <span v-if="row.customerName">{{ row.customerName }}-</span>
            <span>{{ row.receiverName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="订单金额"
        width="100"
        :resizable="false">
        <template slot-scope="{row}">
          <div>¥{{ row.totalAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="订单来源"
        width="100"
        :resizable="false">
        <template slot-scope="{row}"> {{ row.source | sourceName() }}</template>
      </el-table-column>
      <el-table-column
        label="订单状态"
        width="90"
        :resizable="false">
        <template slot-scope="{row}"> {{ row.status | orderStatusName() }} </template>
      </el-table-column>
      <el-table-column
        label="发货状态"
        :resizable="false">
        <template slot-scope="{row}"> {{ row.outStatus | orderOutStatusName() }} </template>
      </el-table-column>
      <el-table-column
        label="发货方式"
        width="90"
        :resizable="false">
        <template slot-scope="{row}">
          <!-- {{ row.outType | orderOutTypeName() }}  -->
          <span v-if="row.outType === 0">待定</span>
          <span v-if="row.outType === 1 && row.orderFlag === '1'">正常发货</span>
          <span v-if="row.outType === 1 && row.orderFlag === '2'">改单发货</span>
          <span v-if="row.outType === 2 && row.orderFlag === '3'">空包发货</span>
          <span v-if="row.outType === 1 && row.orderFlag === '3'">刷单发货</span>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        min-width="180"
        prop="remark"
        :resizable="false">
      </el-table-column>
      <el-table-column
        label="交易时间"
        :resizable="false"
        width="140">
        <template slot-scope="{row}"> {{ row.tradeTime | dateformat( ) }} </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        :resizable="false"
        width="240">
        <template slot-scope="{row}">
          <el-button
            type="primary"
            @click.native="check(row)">审单</el-button>
          <el-button
            :disabled="!(row.source === 9)"
            type="danger"
            @click.native="salescancel(row)">删除</el-button>
          <el-dropdown>
            <el-button
              type="info"
              style="margin-left: 10px">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="editremark(row)">修改备注</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-if="!noPager"
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <order-audit-modal
      ref="audit"
      :callback="batchCallback" />
    <order-audit-modal-new
      ref="batch"
      :callback="batchCallback" />

    <order-remark-modal
      ref="remark"
      :callback="fetchList" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OrderAuditModal from './busi/order-audit-modal.vue'
import NP from 'number-precision'
import OrderAuditModalNew from './busi/order-audit-modal-new.vue'
import OrderSourceSelect from './order-source-select.vue'
import DateRangeSelect from './date-range-select.vue'
import moment from 'moment'
import NoPagerCheckbox from '../../components/no-pager-checkbox.vue'
import OrderRemarkModal from './busi/order-remark-modal.vue'
export default {
  name: 'OrderTableAudit',
  components: { OrderRemarkModal, OrderAuditModal, OrderAuditModalNew, OrderSourceSelect, DateRangeSelect, NoPagerCheckbox },
  props: {
    outType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      noPager: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        code: '',
        status: 0,
        outStatus: 0,
        receiverName: null,
        outType: 0,
        source: null,
        saleDepartmentName: null,
        saleStaffName: null,
        remark: ''
        // outStatusList: [0, 1]
      },
      daterange: null,
      list: [],
      multipleSelection: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    editremark(row) {
      this.$refs.remark.fetch({
        salesOrderId: row.id,
        remark: row.remark,
        code: row.code
      })
    },
    pagerNo() {
      this.config.pageSize = 1000000
      this.handleCurrentChange(1)
    },
    pagerYes() {
      this.config.pageSize = 10
      this.handleCurrentChange(1)
    },
    salescancel(row) {
      this.$confirm('此操作将删除该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/salesdelete', {
            payload: {
              code: row.code
            },
            success: () => {
              this.loading = false
              // this.$refs.table.clearSelection()
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    selectable(row) {
      return (row.receiverAddress && row.receiverCity && row.receiverDistrict && row.receiverName && row.receiverProvince) && (row.receiverMobile || row.receiverTel)
    },
    check(row) {
      this.$refs.audit.fetch(row.id)
    },
    batchCheck() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先勾选订单')
        return
      }
      this.$refs.batch.fetch(this.multipleSelection)
    },
    batchCallback() {
      // this.$refs.table.clearSelection()
      this.fetchList()
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      // this.$refs.table.clearSelection()

      this.loading = true
      const [tradeTimeStart, tradeTimeEnd] = this.daterange || [null, null]
      this.$store.dispatch('outstock/getsaleslist', {
        payload: {
          ...this.config,
          receiverName: this.config.receiverName || null,
          tradeTimeStart: +moment(tradeTimeStart).startOf('days'),
          tradeTimeEnd: +moment(tradeTimeEnd).endOf('days')
          // outType: this.outType === -1 ? null : this.outType
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records.map(i => ({
            ...i,
            totalAmount: NP.divide(i.totalAmount, 100),
            itemAmount: NP.divide(i.itemAmount, 100),
            discountAmount: NP.divide(i.discountAmount, 100)
          }))
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
